import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function TermsAndConditions() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="cm-page container" style={{ textAlign: 'left', marginTop: '100px' }}>
            <div className="cm-hero-section">
                <h1 className="cm-hero-title">Terms and Conditions</h1>
                {/* <p className="cm-hero-subtitle">Effective Date: December 16, 2025</p> */}
            </div>

            <div className="cm-content-section">
                <div className="cm-content-wrapper">
                    <section className="cm-section">
                        <p className="cm-intro-text">
                            Welcome to <strong>Profit Technologies</strong>. These Terms and Conditions ("Terms") govern your use of our website,
                            services, and products. By accessing or using our services, you agree to be bound by these Terms.
                            Please read them carefully before engaging with our platform.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">1. Acceptance of Terms</h2>
                        <p className="cm-text">
                            By accessing or using the services provided by Profit Technologies, you acknowledge that you have read,
                            understood, and agree to comply with these Terms and Conditions. If you do not agree with any part of
                            these Terms, you must discontinue use of our services immediately.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">2. Services Provided</h2>
                        <p className="cm-text">
                            Profit Technologies is a leading IT company specializing in:
                        </p>
                        <ul className="cm-list">
                            <li>Website Development</li>
                            <li>Mobile Application Development</li>
                            <li>Software Development & Custom Solutions</li>
                            <li>Digital Marketing & SEO Services</li>
                            <li>IT Consulting & Strategy</li>
                            <li>Startup Consulting & MVP Development</li>
                            <li>Cloud Solutions & Infrastructure Management</li>
                        </ul>
                        <p className="cm-text">
                            We reserve the right to modify, suspend, or discontinue any service at any time without prior notice.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">3. User Responsibilities</h2>
                        <p className="cm-text">As a user of our services, you agree to:</p>
                        <ul className="cm-list">
                            <li>Provide accurate, current, and complete information during registration or consultation</li>
                            <li>Maintain the confidentiality of your account credentials</li>
                            <li>Use our services in compliance with all applicable laws and regulations</li>
                            <li>Not engage in any activity that disrupts or interferes with our services</li>
                            <li>Not use our services for any illegal, fraudulent, or unauthorized purposes</li>
                            <li>Respect intellectual property rights of Profit Technologies and third parties</li>
                        </ul>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">4. Intellectual Property Rights</h2>
                        <p className="cm-text">
                            All content, materials, software, code, designs, graphics, logos, and other intellectual property
                            provided by Profit Technologies remain our exclusive property unless otherwise stated in a written agreement.
                            You may not reproduce, distribute, modify, or create derivative works without our express written consent.
                        </p>
                        <p className="cm-text">
                            Upon full payment for custom development services, clients receive ownership rights to the deliverables
                            as specified in the project agreement. However, Profit Technologies retains the right to use
                            general methodologies, techniques, and non-confidential knowledge gained during the project.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">5. Payment Terms</h2>
                        <p className="cm-text">
                            Payment terms are established on a project-by-project basis and outlined in individual service agreements:
                        </p>
                        <ul className="cm-list">
                            <li>All fees must be paid in accordance with the payment schedule agreed upon</li>
                            <li>Late payments may incur additional charges or suspension of services</li>
                            <li>Refunds are subject to our refund policy as stated in individual contracts</li>
                            <li>All prices are quoted in the currency specified in the agreement</li>
                            <li>Clients are responsible for any applicable taxes unless otherwise stated</li>
                        </ul>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">6. Project Delivery & Timelines</h2>
                        <p className="cm-text">
                            Profit Technologies strives to deliver all projects within agreed timelines. However, delivery dates
                            are estimates and may be subject to change due to:
                        </p>
                        <ul className="cm-list">
                            <li>Delays in client feedback or approval</li>
                            <li>Scope changes or additional requirements</li>
                            <li>Technical complexities or unforeseen challenges</li>
                            <li>Force majeure events beyond our reasonable control</li>
                        </ul>
                        <p className="cm-text">
                            We commit to transparent communication regarding any potential delays.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">7. Confidentiality</h2>
                        <p className="cm-text">
                            Profit Technologies respects the confidentiality of client information. We will not disclose, share,
                            or use confidential information for purposes other than fulfilling our contractual obligations,
                            except as required by law or with your explicit consent.
                        </p>
                        <p className="cm-text">
                            Clients are expected to maintain confidentiality regarding any proprietary information, trade secrets,
                            or methodologies shared by Profit Technologies during the engagement.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">8. Limitation of Liability</h2>
                        <p className="cm-text">
                            To the maximum extent permitted by law, Profit Technologies shall not be liable for any indirect,
                            incidental, special, consequential, or punitive damages arising from:
                        </p>
                        <ul className="cm-list">
                            <li>Use or inability to use our services</li>
                            <li>Unauthorized access to or alteration of your data</li>
                            <li>Loss of profits, revenue, or business opportunities</li>
                            <li>System failures, errors, or interruptions</li>
                        </ul>
                        <p className="cm-text">
                            Our total liability for any claim arising from our services shall not exceed the amount paid by
                            the client for the specific service in question.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">9. Warranties and Disclaimers</h2>
                        <p className="cm-text">
                            Profit Technologies warrants that services will be performed with professional skill and care.
                            However, we provide our services "as is" and make no warranties regarding:
                        </p>
                        <ul className="cm-list">
                            <li>Uninterrupted or error-free operation</li>
                            <li>Achievement of specific business outcomes</li>
                            <li>Compatibility with all third-party systems</li>
                            <li>Security against all potential cyber threats</li>
                        </ul>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">10. Termination</h2>
                        <p className="cm-text">
                            Either party may terminate services under the following conditions:
                        </p>
                        <ul className="cm-list">
                            <li>Material breach of these Terms by the other party</li>
                            <li>Written notice as specified in the service agreement</li>
                            <li>Mutual written agreement</li>
                        </ul>
                        <p className="cm-text">
                            Upon termination, the client remains liable for all fees incurred up to the termination date.
                            Profit Technologies will provide deliverables completed up to that point, subject to full payment.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">11. Modifications to Terms</h2>
                        <p className="cm-text">
                            Profit Technologies reserves the right to modify these Terms at any time. We will notify users of
                            significant changes via email or website announcement. Continued use of our services after such
                            modifications constitutes acceptance of the updated Terms.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">12. Governing Law</h2>
                        <p className="cm-text">
                            These Terms shall be governed by and construed in accordance with the laws of India. Any disputes
                            arising from these Terms or our services shall be subject to the exclusive jurisdiction of the
                            courts in Gurgaon, Haryana, India.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">13. Third-Party Services</h2>
                        <p className="cm-text">
                            Our services may integrate with third-party platforms, tools, or APIs. Profit Technologies is not
                            responsible for the availability, functionality, or policies of third-party services. Your use of
                            such services is subject to their respective terms and conditions.
                        </p>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">14. Indemnification</h2>
                        <p className="cm-text">
                            You agree to indemnify and hold harmless Profit Technologies, its directors, employees, and partners
                            from any claims, damages, losses, or expenses (including legal fees) arising from:
                        </p>
                        <ul className="cm-list">
                            <li>Your violation of these Terms</li>
                            <li>Your misuse of our services</li>
                            <li>Infringement of third-party rights</li>
                            <li>Any content or data you provide to us</li>
                        </ul>
                    </section>

                    <section className="cm-section">
                        <h2 className="cm-section-title">15. Contact Information</h2>
                        <p className="cm-text">
                            If you have any questions, concerns, or feedback regarding these Terms and Conditions, please contact us:
                        </p>
                        <div className="cm-contact-info">
                            <p><strong>Profit Technologies</strong></p>
                            <p>Contact: <Link to="/contact">ProfitTechnologies.org/contact</Link></p>
                            <p>Address: Gurgaon, Haryana, India</p>
                            <p>Business Hours: Monday - Friday, 9:00 AM - 6:00 PM IST</p>
                        </div>
                    </section>

                    <section className="cm-section">
                        <div className="cm-acknowledgment">
                            <p className="cm-text">
                                <strong>By using our services, you acknowledge that you have read, understood, and agree to be
                                    bound by these Terms and Conditions.</strong>
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
